exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tag-input[data-v-e1567448]{line-height:normal;border:1px solid #dddee1;border-radius:4px;padding:0 0 0 0;display:-webkit-box;display:-ms-flexbox;display:flex}.product-upload-list[data-v-e1567448]{width:200px;height:200px}.classify_style[data-v-e1567448] .ivu-form-item-label:before{content:\"*\";display:inline-block;margin-right:4px;line-height:1;font-family:SimSun;font-size:14px;color:#ed4014}", ""]);

// exports
